<template>
  <el-dialog :title="dialogMode === 'edit' ? '编辑目标明细' : '新增目标明细'" :visible.sync="localVisible" width="1000px" :close-on-click-modal="false" append-to-body
    custom-class="add-objective-dialog" @close="handleClose">
    <div class="form-box">
      <el-form v-loading="loading" :model="form" :rules="rules" ref="formRef" label-width="130px" size="small"
        class="objective-form">
        <el-form-item label="管家：" prop="serviceUserId">
          <el-select v-model="form.serviceUserId" placeholder="请选择" filterable class="full-width">
            <el-option v-for="item in serviceUser" :key="item.serviceUserId" :label="item.serviceUserName" :value="item.serviceUserId" />
          </el-select>
        </el-form-item>

        <el-form-item label="服务单总目标：" prop="serviceOrderTotalObjective">
          <el-input v-model.number="form.serviceOrderTotalObjective" placeholder="请输入" class="full-width" />
        </el-form-item>

        <el-form-item label="商品单总目标：" prop="productOrderTotalObjective">
          <el-input v-model.number="form.productOrderTotalObjective" placeholder="请输入" class="full-width" />
        </el-form-item>

        <el-form-item label="年度：" prop="annual">
          <el-select v-model="form.annual" placeholder="请选择" class="full-width">
            <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>

        <el-form-item label="月度：" prop="months">
          <el-select v-model="form.months" placeholder="请选择" multiple collapse-tags class="full-width">
            <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item < 10 ? '0' + item : '' + item" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="month-inputs-container">
        <div v-if="sortedMonths.length > 0" class="month-inputs-title">月度目标分配</div>
        <el-form v-if="sortedMonths.length > 0" :model="form.monthValues" ref="monthFormRef" label-width="80px" size="small" class="month-form">
          <el-form-item v-for="mStr in sortedMonths" :key="mStr" :label="parseInt(mStr, 10) + '月：'" :prop="mStr"
            :rules="[{ required: true, message: '请输入目标值', trigger: 'blur' }, { type: 'number', message: '必须为数字', trigger: 'blur' }]">
            <el-input v-model.number="form.monthValues[mStr]" placeholder="请输入" />
          </el-form-item>
        </el-form>
        <div v-else class="empty-tip">请先在左侧选择月度</div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submitLoading" class="submit-btn" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveOrUpdateEmployeeAssessmentTarget } from '@/common/api';

export default {
  name: 'AddDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogMode: {
      type: String,
      default: 'add'
    },
    rowData: {
      type: Object,
      default: () => null
    },
    serviceUser: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // 正整数验证器
    const validatePositiveInteger = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback(new Error('请输入目标值'));
      } else if (!Number.isInteger(value) || value <= 0) {
        callback(new Error('目标值必须为正整数'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      submitLoading: false,
      yearOptions: [],
      form: {
        serviceUserId: '',
        serviceOrderTotalObjective: '',
        productOrderTotalObjective: '',
        annual: '',
        months: [],
        monthValues: {
          '01': '', '02': '', '03': '', '04': '', '05': '', '06': '',
          '07': '', '08': '', '09': '', '10': '', '11': '', '12': ''
        }
      },
      rules: {
        serviceUserId: [{ required: true, message: '请选择管家', trigger: 'change' }],
        serviceOrderTotalObjective: [
          { required: true, validator: validatePositiveInteger, trigger: 'blur' }
        ],
        productOrderTotalObjective: [
          { required: true, validator: validatePositiveInteger, trigger: 'blur' }
        ],
        annual: [{ required: true, message: '请选择年度', trigger: 'change' }],
        months: [{ type: 'array', required: true, message: '请选择月度', trigger: 'change' }]
      }
    };
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    sortedMonths() {
      if (!this.form.months) return [];
      return [...this.form.months].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.generateYearOptions();

        if (this.dialogMode === 'edit' && this.rowData) {
          // 编辑回显逻辑
          const agent = this.serviceUser.find(item => Number(item.serviceUserId) === Number(this.rowData.employeeId));
          this.form = {
            serviceUserId: agent ? agent.serviceUserId : '',
            serviceOrderTotalObjective: Number(this.rowData.serviceOrderTotalObjective) || '',
            productOrderTotalObjective: Number(this.rowData.productOrderTotalObjective) || '',
            annual: (this.rowData.annual || '').replace('年', ''),
            months: [],
            monthValues: {}
          };

          const monthVals = {
            '01': '', '02': '', '03': '', '04': '', '05': '', '06': '',
            '07': '', '08': '', '09': '', '10': '', '11': '', '12': ''
          };
          const months = [];
          for (let i = 1; i <= 12; i++) {
            const mVal = Number(this.rowData[`month${i}`]);
            if (mVal > 0) {
              const mStr = i < 10 ? '0' + i : String(i);
              months.push(mStr);
              monthVals[mStr] = mVal;
            }

          }
          this.form.months = months;
          this.form.monthValues = monthVals;
        } else {
          // 新增逻辑，重置表单
          this.form = {
            serviceUserId: '',
            serviceOrderTotalObjective: '',
            productOrderTotalObjective: '',
            annual: '',
            months: [],
            monthValues: {
              '01': '', '02': '', '03': '', '04': '', '05': '', '06': '',
              '07': '', '08': '', '09': '', '10': '', '11': '', '12': ''
            }
          };
        }

        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate();
        });
      }
    }
  },
  methods: {
    // 动态生成年度选项 (当前年-2到+15年)
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 2; i <= currentYear + 15; i++) {
        years.push(String(i));
      }
      this.yearOptions = years;
    },
    // 关闭重置
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.$refs.monthFormRef && this.$refs.monthFormRef.resetFields();
      this.form = {
        serviceUserId: '',
        serviceOrderTotalObjective: '',
        productOrderTotalObjective: '',
        annual: '',
        months: [],
        monthValues: {
          '01': '', '02': '', '03': '', '04': '', '05': '', '06': '',
          '07': '', '08': '', '09': '', '10': '', '11': '', '12': ''
        }
      };
      this.$emit('update:visible', false);
    },
    // 表单提交
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 校验右侧月度表单
          let monthValid = true;
          if (this.$refs.monthFormRef && this.form.months.length > 0) {
            await new Promise((resolve) => {
              this.$refs.monthFormRef.validate((v) => {
                monthValid = v;
                resolve();
              });
            });
          }
          if (!monthValid) {
            return false;
          }

          this.submitLoading = true;
          try {
            const payload = {
              employeeId: Number(this.form.serviceUserId),
              year: Number(this.form.annual),
              serviceOrderTarget: Number(this.form.serviceOrderTotalObjective),
              productOrderTarget: Number(this.form.productOrderTotalObjective),
            };
            if (this.dialogMode === 'edit' && this.rowData && this.rowData.id) {
              payload.id = this.rowData.id;
            }
            for (let i = 1; i <= 12; i++) {
              const mStr = i < 10 ? '0' + i : String(i);
              const key = `month${i}`;
              if (this.form.months && this.form.months.includes(mStr)) {
                payload[key] = Number(this.form.monthValues[mStr]) || 0;
              } else {
                payload[key] = 0;
              }
            }
            console.log('handleSubmit payload:', JSON.stringify(payload))
            const res = await saveOrUpdateEmployeeAssessmentTarget(payload);
            if (res && (res.code === 0 || res.code === 200 || res.code === '200')) {
              this.$message.success(this.dialogMode === 'edit' ? '修改成功' : '提交成功');
              this.$emit('success', { ...this.form });
              this.localVisible = false;
            } else {
              this.$message.error((res && res.msg) || '保存失败');
            }
          } catch (err) {
            console.error('handleSubmit error:', err);
            this.$message.error('提交失败，请重试');
          } finally {
            this.submitLoading = false;
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.full-width {
  width: 100%;
}
.form-box{
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.objective-form {
  flex: 1;
}

.month-inputs-container {
  flex: 1;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 20px;
  background-color: #fafafa;
  
  .month-inputs-title {
    font-size: 15px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 10px;
  }
  
  .empty-tip {
    color: #909399;
    text-align: center;
    margin-top: 50px;
  }
  
  .month-form {
    max-height: 380px;
    overflow-y: auto;
    padding-right: 10px;
  }
}

::v-deep .add-objective-dialog {
  border-radius: 8px;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #f0f0f0;

    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
    }
  }

  .el-dialog__body {
    padding: 30px 40px 10px 40px;
  }

  .objective-form {
    .el-form-item {
      margin-bottom: 24px;

      .el-form-item__label {
        font-weight: 500;
        color: #606266;
        padding-right: 16px;
        white-space: nowrap;
      }

      .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:focus {
          border-color: #3388ff;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    padding-bottom: 24px;

    .submit-btn {
      width: 160px;
      height: 38px;
      font-size: 14px;
      font-weight: 600;
      background-color: #3b7bdf;
      border-color: #3b7bdf;
      border-radius: 4px;
      letter-spacing: 2px;
      transition: all 0.3s ease;

      &:hover {
        background-color: #4da6ff;
        border-color: #4da6ff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(59, 123, 223, 0.3);
      }

      &:active {
        transform: translateY(0);
        box-shadow: none;
      }
    }
  }
}
</style>